import React, { Fragment } from 'react';
import './videoLoop.scss';

function VideoLoop({ data }) {
  return (
    <Fragment>
      <video autoPlay muted playsInline loop className="videoLoop videoLoop-l">
        <source src={data.videoD} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
      <video autoPlay muted playsInline loop className="videoLoop videoLoop-s">
        <source src={data.videoM} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
    </Fragment>
  );
}

export default VideoLoop;
